<div class="statsRow">
  @for (stat of stats; track stat) {
    <div class="statTile">
      <div class="statIcon" [style.color]="stat.accent" [style.background]="stat.accent + '1a'">
        <i class="fas {{ stat.icon }}"></i>
      </div>
      <div class="statContent">
        <div class="statValue">{{ stat.value === null ? '—' : stat.value }}</div>
        <div class="statLabel">{{ stat.label }}</div>
      </div>
    </div>
  }
</div>
